export default async function () {
  // Для Safari
  (await import("smoothscroll-polyfill")).default.polyfill()
}
